import { useTranslation } from "@/core/i18n";
import { Button } from "atoms/button/Button";
import { DraggableModal } from "atoms/draggable-modal/DraggableModal";
import { TextButton } from "atoms/text-button/TextButton";

type LocationPreAskSheetProps = {
  open: boolean;
  onAllow: () => void;
  onDecline: () => void;
};

/**
 * Explains why sign-up wants the patient's position before the system prompt appears. The OS
 * shows that prompt once, so a patient who would decline it declines this sheet instead and can
 * still be asked later — by the arrival-reminder primer after their first purchase or visit.
 * Dragging the sheet away or tapping the backdrop counts as choosing manually.
 */
export const LocationPreAskSheet = ({ open, onAllow, onDecline }: LocationPreAskSheetProps) => {
  const { t } = useTranslation();

  return (
    <DraggableModal
      bodyClassName="px-5 pt-4"
      footer={
        <div className="flex flex-col items-center gap-2 px-5 pb-6 pt-4">
          <Button fullWidth onClick={onAllow}>
            {t("v3LocationPicker.preAskAllow")}
          </Button>
          <TextButton onClick={onDecline}>{t("v3LocationPicker.preAskDecline")}</TextButton>
        </div>
      }
      onClose={onDecline}
      open={open}
    >
      <div className="flex flex-col gap-2 text-center">
        <span className="text-h5">{t("v3LocationPicker.preAskTitle")}</span>
        <span className="text-body2 text-secondary">{t("v3LocationPicker.preAskBody")}</span>
      </div>
    </DraggableModal>
  );
};
